import React, { useEffect, useState } from "react";
import { useMutation, useQuery } from "react-query";

import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import {
  getCategories,
  showCategories,
  storeCategories,
  updateCategories,
} from "../../../MyApi/product/categories";
import LangSelectModal from "../../../Components/UI/langselectmodal";
import i18next from "i18next";
import { toast } from "react-toastify";
import { getSections } from "../../../MyApi/section";
import Select from "react-select";
import SkeletonWrapper from "../../../Components/UI/skeletonWrapper";
import EnhancedSearchStore from "../../../Components/UI/enhancedstoresearch";
const StoreCategoryModal = ({
  isOpen,
  toggle,
  refetch,
  modalMode,
  modalId,
  initialStoreId,
  initialStoreName,
}) => {
  const [formData, setFormData] = useState({
    name: "",
    is_active: 1,
    section_ids: null,
    store_id: "",
    store_name: "",
    sort_order: "",
    is_featured: 0,
    parent_id: "",
    icon: "",
  });

  const lang = i18next.language;
  const [selectedCodeLang, setSelectedLangCode] = useState("");
  const [error, setError] = useState("");
  const { data } = useQuery("getCategories", () => getCategories());
  const { data: showCategoriesData, isLoading } = useQuery(
    ["showCategories", modalId, selectedCodeLang],
    () => showCategories(modalId, selectedCodeLang),
    { enabled: modalMode === "edit" },
  );
  const { data: sectionsData } = useQuery(["getSections"], () => getSections());
  const categories = data?.data?.categories || [];
  const category = showCategoriesData?.data?.category || [];
  const sections = sectionsData?.data?.sections || [];

  useEffect(() => {
    if (modalMode === "edit" && showCategoriesData) {
      setFormData({
        name: category?.name,
        section_ids: category.sections,
        is_active: category?.is_active ? 1 : 0,
        sort_order: category?.sort_order,
        is_featured: category?.is_featured ? 1 : 0,
        parent_id: category?.parent_id ?? "",
        icon: category?.icon ?? "",
        store_id: category?.store?.id ?? "",
        store_name: category?.store?.name ?? "",
      });
    }
  }, [showCategoriesData]);

  useEffect(() => {
    if (modalMode === "add" && initialStoreId) {
      setFormData((prev) => ({
        ...prev,
        store_id: initialStoreId,
        store_name: initialStoreName || "",
      }));
    }
  }, [initialStoreId, initialStoreName, modalMode]);

  useEffect(() => {
    setSelectedLangCode(lang);
  }, []);
  const mutation = useMutation({
    mutationKey: ["postCategories"],
    mutationFn: storeCategories,
    onSuccess: (data) => {
      toast.success(`${data.message}`);
      toggle();
      refetch();
      setFormData({
        name: "",
        is_active: 1,
        sort_order: "",
        is_featured: 0,
        parent_id: "",
      });
      setError("");
    },
    onError: (error) => {
      setError(error?.response?.data?.message);
    },
  });

  const mutationUpdate = useMutation({
    mutationKey: ["updateCategories"],
    mutationFn: (postData) => updateCategories(postData, modalId),
    onSuccess: (data) => {
      toast.success(`${data.message}`);
      toggle();
      refetch();
      setFormData({
        name: "",
        is_active: 1,
        sort_order: "",
        is_featured: 0,
        parent_id: "",
      });
      setError("");
    },
    onError: (error) => {
      setError(error?.response?.data?.message);
    },
  });

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]:
        type === "checkbox"
          ? checked
            ? 1
            : 0
          : type === "file"
            ? files?.[0]
            : value,
    }));
  };

  const handleSelectLangCode = (e) => {
    setSelectedLangCode(e.target.value);
  };

  const handleChangeSectionIds = (selectedOptions) => {
    setFormData((prev) => ({
      ...prev,
      section_ids: selectedOptions,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.name.trim()) {
      setError("الاسم مطلوب");
      return;
    }
    const sendData = new FormData();
    sendData.append("name", formData.name);
    sendData.append("is_active", formData.is_active);
    sendData.append("is_featured", formData.is_featured);
    sendData.append("parent_id", formData.parent_id);
    sendData.append("sort_order", formData.sort_order);
    if (formData.store_id) {
      sendData.append("store_id", formData.store_id);
    }

    if (formData.icon && formData.icon instanceof File) {
      sendData.append("icon", formData.icon);
    }

    formData.section_ids.forEach((item, i) => {
      sendData.append(`section_ids[${i}]`, item.id);
    });

    if (modalMode === "edit") {
      sendData.append("lang", selectedCodeLang);
      sendData.append("_method", "PUT");
      mutationUpdate.mutate(sendData);
    } else {
      mutation.mutate(sendData);
    }
  };

  const setStoreId = (id, name) => {
    setFormData((prev) => ({ ...prev, store_id: id, store_name: name }));
  };
  return (
    <Modal isOpen={isOpen} toggle={toggle} className="add">
      <ModalHeader toggle={toggle}>
        {modalMode === "edit" ? " تعديل فئة   " : " إضافة فئة  جديدة"}
      </ModalHeader>
      <form onSubmit={handleSubmit}>
        <ModalBody>
          {error && <div className="alert alert-danger">{error}</div>}
          {modalMode === "edit" && (
            <LangSelectModal
              selectedLangCode={selectedCodeLang}
              handleChange={handleSelectLangCode}
            />
          )}
          <label htmlFor="" className="form-label">
            المتجر
          </label>
          <EnhancedSearchStore
            setStoreId={setStoreId}
            value={
              formData.store_id
                ? { id: formData.store_id, name: formData.store_name }
                : null
            }
          />
          <label htmlFor="" className="form-label">
            القسم
          </label>
          <SkeletonWrapper isLoading={isLoading}>
            <Select
              name="section_id"
              isMulti
              isClearable
              getOptionLabel={(e) => e.name}
              getOptionValue={(e) => e.id}
              onChange={handleChangeSectionIds}
              isLoading={isLoading}
              options={sections}
              value={formData.section_ids}
              placeholder="اختار قسم او عده اقسام"
            ></Select>
          </SkeletonWrapper>
          <FormGroup>
            <Label for="name">الاسم</Label>
            <SkeletonWrapper isLoading={isLoading}>
              <Input
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="اكتب اسم التصنيف"
                required
              />
            </SkeletonWrapper>
          </FormGroup>

          <FormGroup>
            <Label for="sort_order">ترتيب العرض</Label>
            <SkeletonWrapper isLoading={isLoading}>
              <Input
                id="sort_order"
                name="sort_order"
                type="number"
                value={formData.sort_order}
                onChange={handleChange}
                placeholder="اختياري"
              />
            </SkeletonWrapper>
          </FormGroup>

          <FormGroup className="mt-3">
            <Label for="parent_id"> الفئة الأب</Label>
            <SkeletonWrapper isLoading={isLoading}>
              <select
                id="parent_id"
                name="parent_id"
                className="form-select"
                value={formData.parent_id}
                onChange={handleChange}
                placeholder="اختياري"
              >
                <option value={""}>اختر فئة</option>
                {categories.map((category) => (
                  <option key={category.id} value={category.id}>
                    {category.name}
                  </option>
                ))}
              </select>
            </SkeletonWrapper>
          </FormGroup>
          <FormGroup>
            <label htmlFor="" className="form-label">
              الايقون
            </label>
            <SkeletonWrapper isLoading={isLoading}>
              <input
                name="icon"
                type="file"
                className="form-control"
                onChange={handleChange}
              />
            </SkeletonWrapper>
            {formData.icon && (
              <img
                src={
                  formData.icon instanceof File
                    ? URL.createObjectURL(formData.icon)
                    : formData.icon
                }
                alt="الايقون"
                width={200}
                height={200}
                className="img-fluid"
              />
            )}
          </FormGroup>
        </ModalBody>

        <ModalFooter className="d-flex justify-content-start">
          <button className="btn btn-white" onClick={toggle}>
            إلغاء
          </button>
          <Button
            color="primary"
            type="submit"
            disabled={mutation.isLoading || mutationUpdate.isLoading}
          >
            {mutation.isLoading || mutationUpdate.isLoading
              ? "جاري الحفظ..."
              : "حفظ"}
          </Button>
        </ModalFooter>
      </form>
    </Modal>
  );
};

export default StoreCategoryModal;
